import React from 'react';

import * as S from './loader.styles';

import type { TLoaderConfig, TWebMotorsConfig } from './loader.types';

const WebMotors = React.memo(function WebMotors({ title, titleId }: TWebMotorsConfig) {
	return (
		<S.WebMotorsContent>
			<svg viewBox="0 0 250 250" aria-labelledby={titleId || title}>
				<rect x="50" y="50" className="st0" width="150" height="150" />
				<title>{title || 'Webmotors Loader'}</title>
				<path
					className="st1"
					d="M68,83v84.3v-32.2c0-5.3,4.4-9.7,9.7-9.7l0,0h37.2l0,0c5.3,0,10-4.4,10-10v-0.3V77.4v58v37.1v-37.4 c0-5.3,4.4-9.7,9.7-9.7l0,0h37.2l0,0c5.6,0,10-4.7,10-10l0,0V83c0,0,0,58.5,0,84.1"
				/>
				<path
					className="st2"
					d="M124.8,5.5C58.6,5.5,5.2,58.9,5.2,124.8s53.4,119.6,119.6,119.6c65.9,0,119.6-53.4,119.6-119.6 C244.1,58.9,190.7,5.5,124.8,5.5z M191.3,166c0,5.6-4.7,10-10.3,10c-5.3-0.3-9.4-5-9.4-10.3v-25.6c0-2.8-2.5-5.3-5.3-5.3h-26.5 c-2.8,0-5.3,2.5-5.3,5.3v31.9c0,5.6-4.7,10-10.3,10c-5.3-0.3-9.4-5-9.4-10.3v-31.2c0-2.8-2.5-5.3-5.3-5.3H83c-2.8,0-5.3,2.5-5.3,5.3 v26.2c0,5.6-4.7,10-10.3,10c-5.3-0.3-9.4-5-9.4-10.3V83.6c0-5.6,4.7-10,10.3-10c5.3,0.3,9.4,5,9.4,10.3v25.6c0,2.8,2.5,5.3,5.3,5.3 h26.5c2.8,0,5.3-2.5,5.3-5.3V78c0-5.6,4.7-10,10.3-10c5.3,0.3,9.4,5,9.4,10.3v31.2c0,2.8,2.5,5.3,5.3,5.3h26.5 c2.8,0,5.3-2.5,5.3-5.3V83.9c0-5.3,4.1-10,9.4-10.3c5.6-0.3,10.3,4.4,10.3,10V166z"
				/>
				<circle className="st3" r="11" cx="67.8" cy="83.1" />
			</svg>
		</S.WebMotorsContent>
	);
});

WebMotors.displayName = 'WebMotors';

const Loader = React.memo(function Loader({ type = 'webmotors', className, ...props }: TLoaderConfig) {
	return (
		<S.Container className={className}>
			{type === 'spinner' ? (
				<S.Spinner {...props} />
			) : (
				<WebMotors titleId="Webmotors Loader" title="Webmotors Loader" {...props} />
			)}
		</S.Container>
	);
});

Loader.displayName = 'Loader';
export { Loader };
